/// <amd-module name="TFS/Admin/Groups/Pivots/Groups/Redux/GroupsPivotSelectors" />
import { PermissionsGroup, IPermissionsGroupsAwareState, ISearchResultCache } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { IIdentity } from "VSSUI/IdentityPicker";
import { IOperationStatus } from "TFS/Admin/Common/Constants/Constants";
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";

export function getGroups(state: IPermissionsGroupsAwareState): PermissionsGroup[] {
    if (!state || !state.groupsState || !state.groupsState.data) {
        return [];
    }

    return state.groupsState.data.groups;
}

export function getMoreData(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState || !state.groupsState.data) {
        return false;
    }

    return state.groupsState.data.moreData;
}

export function getTotalGroups(state: IPermissionsGroupsAwareState): number {
    if (!state || !state.groupsState || !state.groupsState.data) {
        return 0;
    }

    return state.groupsState.data.totalGroupCount;
}

export function getNumberOfGroupsOnScreen(state: IPermissionsGroupsAwareState): number {
    if (!state || !state.groupsState || !state.groupsState.data) {
        return 0;
    }

    return state.groupsState.data.numberOfGroupsOnScreen;
}

export function getContinuationToken(state: IPermissionsGroupsAwareState): string[] | undefined {
    if (!state || !state.groupsState || !state.groupsState.data) {
        return undefined;
    }

    return state.groupsState.data.continuationToken;
}

export function getShowDeleteGroupDialog(state: IPermissionsGroupsAwareState): boolean {
    if (!state) {
        return false;
    }

    return state.groupsState.showDeleteGroupDialog;
}

export function getShowAddGroupPanel(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }

    return state.groupsState.showAddGroupPanel;
}

export function getSelectedItem(state: IPermissionsGroupsAwareState): PermissionsGroup | undefined {
    if (!state || !state.groupsState || !state.groupsState.selectedItem) {
        return undefined;
    }

    return state.groupsState.selectedItem;
}

export function getGroupOperationResultMessage(state: IPermissionsGroupsAwareState): string {
    if (!state || !state.groupsState) {
        return "";
    }

    return state.groupsState.groupOperationResultMessage;
}

export function getGroupOperationStatus(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }

    return state.groupsState.groupOperationSuccess;
}
export function getGroupOperationSeverity(state: IPermissionsGroupsAwareState): MessageCardSeverity | undefined {
    if (!state || !state.groupsState) {
        return undefined;
    }

    return state.groupsState.groupOperationSeverity;
}

export function getShowMessageCardStatus(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }

    return state.groupsState.showMessageCard;
}

export function showLoadingPanel(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return true;
    }
    return state.groupsState.loading;
}

export function getInitComplete(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }
    return state.groupsState.initComplete;
}

export function getSearchResult(state: IPermissionsGroupsAwareState): ISearchResultCache {
    if (!state || !state.groupsState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.groupsState.searchResult;
}

export function isAadOrg(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }
    return state.groupsState.isAadOrg;
}

export function getMultiOperationStatuses(state: IPermissionsGroupsAwareState): IOperationStatus[] {
    if (!state || !state.groupsState || !state.groupsState.multiOperationStatuses) {
        return [];
    }
    return state.groupsState.multiOperationStatuses;
}

export function getToMarkTimeToInteract(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }
    return state.groupsState.toMarkTimeToInteract;
}

export function getPermissionsGroups(state: IPermissionsGroupsAwareState): IIdentity[] {
    if (!state || !state.groupsState) {
        return [];
    }

    return state.groupsState.permissionsGroups;
}

export function doesGroupNameAlreadyExists(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }

    return state.groupsState.groupNameAlreadyExists;
}

export function isAddGroupDisabled(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return true;
    }

    return state.groupsState.isAddGroupDisabled;
}

export function getSupportServicePrincipals(state: IPermissionsGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return true;
    }

    return state.groupsState.supportServicePrincipals;
}